(function () {
    'use strict';

    function createEntityTypesDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/createentitytypes';

       function getCreatePlatformEntityTypes() {
           return $http.get(baseUrl + '/platformentity').then(
                function (response) {
                    return response.data;
                }
            );
       };

        return {
            getCreatePlatformEntityTypes: getCreatePlatformEntityTypes
        }
    }

    createEntityTypesDataService.$inject = ['$http'];

    angular.module('ecap.common').service('createEntityTypesDataService', createEntityTypesDataService);
})();
